import styled, { css } from 'styled-components';

import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { scale130, scale190 } from '@xing-com/tokens';

import { adSlotConfigPublift } from '../../ad-slot-config-publift';
import { useRegisterZone } from '../../hooks';

const SectionCol = styled.div`
  width: 100%;
  margin-bottom: ${scale190};
  display: flex;
  justify-content: center;

  @media ${mediaSmallOrTiny} {
    margin-bottom: 0;
  }
`;

const AdWrapper = styled.div<{ $isBottom: boolean }>`
  min-width: 300px;
  max-width: 336px;
  height: 280px;
  position: relative;
  z-index: 1;

  ${({ $isBottom }) =>
    $isBottom &&
    css`
      margin-top: ${scale130};
      margin-bottom: ${scale130};
    `}

  @media ${mediaConfined} {
    min-width: 728px;
    max-width: 970px;
    height: 250px;

    ${({ $isBottom }) =>
      $isBottom &&
      css`
        margin-top: ${scale190};
        margin-bottom: 0;
      `}
  }
`;

export const DisplayAdStartpageSlotPublift: React.FC<{
  isTop: boolean;
}> = ({ isTop }) => {
  const slotId = adSlotConfigPublift.Startpage[isTop ? 'top' : 'bottom'].id;
  useRegisterZone(slotId);

  return (
    <NoSSR>
      <SectionCol>
        <AdWrapper $isBottom={!isTop}>
          <div
            id={slotId}
            data-fuse={
              isTop
                ? adSlotConfigPublift.Startpage.top.fuseTag
                : adSlotConfigPublift.Startpage.bottom.fuseTag
            }
          ></div>
        </AdWrapper>
      </SectionCol>
    </NoSSR>
  );
};
